import { Navigate, useRoutes } from "react-router-dom";
// layouts
import DashboardLayout from "./layouts/dashboard";
import LogoOnlyLayout from "./layouts/LogoOnlyLayout";
//
import Login from "./pages/Login";
import Register from "./pages/Register";
import User from "./pages/User";
import Site from "./pages/Site";
import NotFound from "./pages/Page404";
import UserDetails from "./pages/UserDetails";
import OrderDetails from "./pages/OrderDetails";
// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    {
      path: "/dashboard",
      element: <DashboardLayout />,
      children: [
        { element: <Navigate to="/dashboard/user" replace /> },
        { path: "user", element: <User /> },
        { path: "site", element: <Site /> },
        { path: "user/userDetails/:uid", element: <UserDetails /> },
        {
          path: "user/userDetails/:uid/oderDetails/:orderId",
          element: <OrderDetails />,
        },
      ],
    },
    {
      path: "/",
      element: <LogoOnlyLayout />,
      children: [
        { path: "login", element: <Login /> },
        { path: "register", element: <Register /> },
        { path: "404", element: <NotFound /> },
        { path: "/", element: <Navigate to="/dashboard" /> },
        { path: "*", element: <Navigate to="/404" /> },
      ],
    },
    { path: "*", element: <Navigate to="/404" replace /> },
  ]);
}
